<div>
  <div class="mx-auto" *ngIf="loadingCategoria">
    <div class="d-flex justify-content-center">
      <strong>{{ inputMessageModal }}</strong>
    </div>
    <div class="d-flex justify-content-center">
      <strong>Espere un momento mientras se carga la información ... 
        <div class="spinner-border" role="status"></div>
      </strong>
    </div>
  </div>
  <div *ngIf="!loadingCategoria">
    <div class="row">
      <div class="col-9">
      </div>
      <div class="col-3">
        <input type="text" [ngModel]="searchT" [class]="'form-control'" placeholder="Buscar..."
          (keyup)="changeSearch($event)">
      </div>
    </div>
    <table datatable [dtTrigger]="dtTriggerCategoria" class="table table-striped table-responsive">
      <thead>
        <tr>
          <th>Acciones</th>
          <th>Id categoría</th>
          <th>Nombre categoría</th>
          <th>Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let categoria of categoriaMantenedor | paginate: {itemsPerPage : 10, currentPage: actualPageCategoria}">
          <td class="td-centered icons">
            <span (click)="onCreateCategoria(categoriaModal,'Editar', categoria)" [ngbTooltip]="'Editar'">
              <img [src]="'assets/icons/pencil.svg'" />
            </span>
            <span (click)="openDeleteModalCategoria(confirmationModal, categoria)" [ngbTooltip]="'Eliminar'">
              <img [src]="'assets/icons/trashcan.svg'" />
            </span>
          </td>
          <td class="td-centered">{{categoria.categoryId}}</td>
          <td class="td-centered">{{categoria.categoryDescription}}</td>
          <td class="td-centered">{{getEstadoLabel(categoria.status)}}</td>
        </tr>
      </tbody>
    </table>
    <pagination-controls (pageChange)="actualPageCategoria = $event" class="pagination"></pagination-controls>
  </div>
</div>

<ng-template #confirmationModal let-modal>
  <app-confirmation-modal [modal]="modal" [tittle]="confirmationModalTittle" [message]="confirmationModalMessage"
    [hasComment]="confirmationModalHasComment" [hasOptions]="confirmationModalHasOptions"
    [isCommentObligatory]="confirmationModalisCommentObligatory" [optionLabel]="confirmationModalOptionLabel"
    [options]="confirmationModalOptions" (accept)="confirmationModalAccept($event.comment, $event.option)">
  </app-confirmation-modal>
</ng-template>

<ng-template #categoriaModal let-modal>
  <app-categoria-modal [modalCategoria]="modal" [mode]="creationMode" [categoria]="categoriaSelected"
    (createEdit)="refreshCategoriasCreateOrUpdate($event)">
  </app-categoria-modal>
</ng-template>
